import { Link, useLocation } from "wouter";
import { Ghost, ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { captureMessage, sanitizeUrlForLogging } from "@/lib/sentry";

export default function NotFound() {
  const [location] = useLocation();

  useEffect(() => {
    const safePath = sanitizeUrlForLogging(location);
    const safeReferrer = document.referrer
      ? sanitizeUrlForLogging(document.referrer)
      : "(none)";
    captureMessage(
      `404 Not Found: ${safePath}`,
      { path: safePath, referrer: safeReferrer, kind: "404" },
      "warning",
    );
  }, [location]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-lg rounded-2xl bg-black/80 backdrop-blur-sm border border-white/10 p-12 md:p-16"
      >
        <Ghost className="h-16 w-16 text-accent mx-auto mb-6 opacity-60" />
        <h1 className="text-6xl md:text-8xl font-heading text-white mb-4 tracking-wide">404</h1>
        <p className="text-xl text-muted-foreground font-light mb-8 leading-relaxed">
          This page doesn't exist — maybe the ink faded.
        </p>
        <Link
          href="/"
          data-testid="button-back-home"
          className="inline-flex items-center justify-center gap-2 bg-accent text-white px-8 py-4 rounded-full uppercase tracking-widest text-xs font-bold font-subheading hover:bg-accent/80 active:scale-[0.97] active:bg-accent/70 transition-all duration-300 shadow-[0_0_15px_rgba(139,92,246,0.4)] hover:shadow-[0_0_25px_rgba(139,92,246,0.6)]"
        >
          <ArrowLeft size={14} /> Back to Home
        </Link>
      </motion.div>
    </div>
  );
}
